import React, { useState, useEffect} from 'react'
import { Table,Container,Row,Card,CardHeader,CardBody,CardFooter, Button, Col } from "reactstrap";
import HeaderEmpty from 'components/Headers/HeaderEmpty';
import {allTimeSalesBySeller} from 'network/ApiAxiosTickets'


const AllTimeSales = () => {
const [sellerTotals, setSellerTotals] = useState({});

    useEffect(() => {
        getReport()
    }, []);

    const getReport = async()=>{
        const res = await allTimeSalesBySeller()
        if(res.data.success) {
            setSellerTotals(res.data.totals)
        }
        
    }

    return (
    <>
        
        <Container fluid>
            <HeaderEmpty/>
            <Row>
                <div className="col mt-6">
                    <Card className="shadow">
                        <CardHeader className="border-0">
                            <h2 className=' float-right'>All Time Sales</h2>
                            
                        </CardHeader>
                        {sellerTotals &&
                        <CardBody>
                            
                            <h3>Totals</h3>
                            

                            {sellerTotals &&
                            <>
                            <h3>Seller Comissions</h3>
                            <Table className="align-items-center table-flush" hover responsive striped>
                                <thead className="thead-light">
                                    <tr>
                                        <th scope="col">Name</th>
                                        <th scope="col">Tickets</th>
                                        <th scope="col">Money</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.entries(sellerTotals).map((row)=>{
                                        console.log(row)
                                        return <tr key={row[0]}><th scope="col">{row[0]}</th><th scope="col">{row[1].tickets}</th><th scope="col">{row[1].money}</th></tr>
                                    })}
                                    
                                </tbody>
                            </Table>
                            </>}
                        </CardBody>
                        }
                        <CardFooter className="py-4">
                            
                        </CardFooter>
                    </Card>
                </div>
            </Row>
        </Container>
    </>
    )
}

export default AllTimeSales
